import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/image/loading-white.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "sv-page-bg" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "sv-page-bg-color" })
], -1)
const _hoisted_2 = { class: "sv-page" }
const _hoisted_3 = { class: "sv-global-loading" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sv-global-load-inner" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("span", null, "Loading...")
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _withDirectives(_createElementVNode("div", _hoisted_3, _hoisted_5, 512), [
        [_vShow, _ctx.requestStore.isLoading]
      ])
    ]))
  ], 64))
}